<template>
  <div class="state-block" :class="{ 'state-block--compact': compact }">
    <v-progress-circular v-if="state === 'loading'" indeterminate color="primary" :size="compact ? 28 : 40" />
    <v-icon v-else :size="compact ? 32 : 48" :color="preset.color">{{ icon || preset.icon }}</v-icon>

    <div v-if="titleText" class="state-block__title">{{ titleText }}</div>
    <div v-if="descriptionText" class="state-block__text">{{ descriptionText }}</div>

    <div v-if="$slots.default || state === 'error'" class="state-block__actions">
      <slot>
        <v-btn v-if="state === 'error'" color="primary" outlined small @click="$emit('retry')">Повторить</v-btn>
      </slot>
    </div>
  </div>
</template>

<script>
// Единый вид состояний экрана: загрузка / пусто / ошибка / нет доступа.
const PRESETS = {
  loading: {
    icon: '', color: 'primary', title: 'Загрузка…', text: '',
  },
  empty: {
    icon: 'mdi-inbox-outline', color: '#BDBDBD', title: 'Нет данных', text: '',
  },
  error: {
    icon: 'mdi-alert-circle-outline', color: 'error', title: 'Не удалось загрузить данные', text: 'Проверьте соединение и попробуйте ещё раз.',
  },
  forbidden: {
    icon: 'mdi-lock-outline', color: '#9E9E9E', title: 'Нет доступа', text: 'У вас нет прав на просмотр этого раздела.',
  },
};

export default {
  name: 'StateBlock',
  props: {
    state: {
      type: String,
      default: 'empty',
      validator: (v) => Object.keys(PRESETS).includes(v),
    },
    title: { type: String, default: null },
    text: { type: String, default: null },
    icon: { type: String, default: null },
    compact: { type: Boolean, default: false },
  },
  computed: {
    preset() {
      return PRESETS[this.state] || PRESETS.empty;
    },
    titleText() {
      return this.title !== null ? this.title : this.preset.title;
    },
    descriptionText() {
      return this.text !== null ? this.text : this.preset.text;
    },
  },
};
</script>

<style scoped lang="scss">
.state-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 48px 16px;
  text-align: center;

  &--compact {
    padding: 16px;
  }

  &__title {
    font-size: 16px;
    font-weight: 600;
    color: #212121;
  }

  &__text {
    max-width: 420px;
    font-size: 14px;
    color: #757575;
  }

  &__actions {
    margin-top: 8px;
  }
}
</style>
